/**
 * Keep a video's play/pause button icon in sync with the video itself.
 *
 * The icon follows the video's own events, so it stays correct however playback starts
 * or stops (autoplay, lazy load, click, loop, lightbox, browser pausing off-screen video):
 * "playing" -> pause icon, "pause" -> play icon, and once on init from video.paused.
 *
 * @param {HTMLVideoElement} video  Video element.
 * @param {Function}         render Called with `true` while playing (show the pause icon)
 *                                  and `false` while paused (show the play icon).
 */
export function bindPlayPauseIcon(video, render) {
	if (!video || typeof render !== 'function' || video.dataset.playIconBound) return;

	video.dataset.playIconBound = '1';

	video.addEventListener('playing', function () {
		render(true);
	});
	video.addEventListener('pause', function () {
		render(false);
	});

	render(!video.paused);
}
